<template>
    <modal id="user-course-progress-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('userCourseProgress')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.USERCOURSEPROGRESS'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        :label="$t('user')"
                        :chooseLabel="$t('user')"
                        type="search-select"
                        list-value-field="full_name"
                        v-model="formData.user_id"
                        :fetch-url="`${apiUrl.TENANT_SELECTABLE_DEPARTMENT_USERS}?without=admin&employee=only&with_auth=yes`"
                        :required="true"
                        :error-message="$errorMessage(errors, 'user_id')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('course')"
                        list-value-field="title"
                        v-model="formData.course_id"
                        :chooseLabel="$t('course')"
                        :error-message="$errorMessage(errors, 'course_id')"
                        :fetch-url="TENANT_SELECTABLE_COURSE"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('userCourseProgresses.score')"
                        type="number"
                        v-model="formData.score"
                        :placeholder="$placeholder('userCourseProgresses.score')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'score')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('status')"
                        list-value-field="translated_name"
                        v-model="formData.status_id"
                        :chooseLabel="$t('status')"
                        :error-message="$errorMessage(errors, 'status_id')"
                        :fetch-url="SELECTABLE_COURSE_STATUS"
                    />
                </div>
            </div>

        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {SELECTABLE_COURSE_STATUS, SELECTABLE_DEPARTMENT, TENANT_SELECTABLE_COURSE} from "../../../../Config/ApiUrl";

import {errorMessageInArray, formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "UserCourseProgressCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {},
            SELECTABLE_DEPARTMENT,
            SELECTABLE_COURSE_STATUS,
            TENANT_SELECTABLE_COURSE,
        }
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            formData = formDataAssigner(new FormData, formData);
            let url = this.apiUrl.USERCOURSEPROGRESS;
            if (this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#candidate-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'user-course-progress-table');
                window.location.reload();
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status !== 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {

            this.formData = {};
            $('#candidate-modal').modal('hide');
            this.toastAndReload(data.message, 'user-course-progress-table')
            this.$emit('input', false);
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    }
}
</script>
